export default __webpack_public_path__ + "static/media/apio.edce9072.svg";